import {Bars3BottomLeftIcon, PhotoIcon, QrCodeIcon, RocketLaunchIcon, Squares2X2Icon} from '@heroicons/react/24/outline';

const iconLookUp: Record<string, any> = {
  Squares2X2Icon: Squares2X2Icon,
  PhotoIcon: PhotoIcon,
  Bars3BottomLeftIcon: Bars3BottomLeftIcon,
  QrCodeIcon: QrCodeIcon,
  RocketLaunchIcon: RocketLaunchIcon,
};

export default iconLookUp;
